module.exports = __webpack_public_path__ + "static/img/geometry6.27415601.png";